
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { DepartmentItemProps } from ".";
import { loading, index, options } from "store/department";

interface ApiDepartmentInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiDepartmentOutputProps = OutputBaseProps<{ list: DepartmentItemProps[]; pagination?: PaginationProps; }, DepartmentItemProps>;

export const apiDepartmentIndex = async (data: ApiDepartmentInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiDepartmentOutputProps>("/api/departments", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiDepartmentOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiDepartmentOutputProps>("/api/departments", { params: { ...data, fields: "id,code,name" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};